import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Answer from "../models/AnswerModel"


const styles = {

    container: {
        width: "100%",
        display:"flex",
    },
    textField: {
        height: "100%",
        marginLeft: 8,
        marginRight: 8,
        flex:1,

    },
};

class AnswerView extends Component {
    static propTypes = {
        // //点击触发的方法
        onFinish: PropTypes.func,
    };
    state = {
        refs_Type: [],
        refs_Text: [],
        dataSource: [],
    };

    constructor(props) {
        super(props);
        this.textField = React.createRef();
    }

    componentWillMount() {

    }

    onFinishAction = (e) => {
        if (e.keyCode === 13) {
            let model = new Answer();
            console.log(this.textField.current.value);
            model.answer = this.textField.current.value;
            console.log("---",model.answer);
            this.props.onFinish(model.toString());
        }
    };

    render() {
        return (
            <div style={styles.container}>
                <TextField
                    id="type"
                    label="answer"
                    style={styles.textField}
                    placeholder="answer"
                    margin="normal"
                    variant="outlined"
                    inputRef={this.textField}
                    autoFocus={true}
                    onKeyUp={this.onFinishAction}
                />
            </div>


        );
    }
}

export default AnswerView;
